import {
  GET_TRANSITION_REQUEST,
  GET_TRANSITION_SUCCESS,
  GET_TRANSITION_FAILURE,
} from "../../../Utils/Constant";

const initialState = {
  data: {},
  loading: false,
  error: null,
};
export const getCreditHistoryReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_TRANSITION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_TRANSITION_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case GET_TRANSITION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
